import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useAnimations from '../../../hooks/useAnimations';
import { device } from '../../../styles/devices';
import FallbackCarDefault from '../../../assets/fallback_car_default.png';
import { SkeletonImage, SkeletonVehicle } from '../../Skeleton';
import ExposedHeader from '../ExposedHeader';
import {
  MobileWrapper,
  VehicleInfoContainer,
  ImageWrapper,
  VehicleImage,
  VehicleName,
  Trimline,
  Title,
  OfferType,
} from '../VehicleInfo.styles';
import { OffersTypes } from '../../../types';
import Offers from '../Offers';

interface OfferSpecificVehicleProps {
  offers: OffersTypes;
  isOfferPage: boolean;
  isVehicleLoading: boolean;
}

const OfferSpecificVehicle: React.FC<OfferSpecificVehicleProps> = ({
  offers,
  isVehicleLoading,
  isOfferPage,
}) => {
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ query: device.tablet });
  const [isOpen, setIsOpen] = useState(false);

  const dropdownHeigh = 464;
  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(isOpen, dropdownHeigh);

  const image = offers?.image ? offers.image : FallbackCarDefault;
  const modelName = offers?.modelName;
  const trimName = offers?.trimName;

  useEffect(() => {
    if (isTablet) setIsOpen(false);
  }, [isTablet]);

  return (
    <>
      {dropdownAnimation(
        (props, item) =>
          item && (
            <MobileWrapper style={props}>
              <VehicleInfoContainer style={filtersAccordianAnimation} data-testid="vehicle-info">
                <ImageWrapper data-testid="vehicle-info-image">
                  <VehicleImage src={image} />
                </ImageWrapper>
                <>
                  <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
                  <Trimline>{trimName}</Trimline>
                </>
                <Offers offers={offers?.offerDetails} offerType={offers.offerType} />
              </VehicleInfoContainer>
            </MobileWrapper>
          ),
      )}
      {!isTablet && (
        <ExposedHeader
          isOpened={isOpen}
          setIsOpened={setIsOpen}
          modelName={modelName}
          isOfferPage={isOfferPage}
          offers={offers}
        />
      )}
      {isTablet && (
        <VehicleInfoContainer data-testid="vehicle-info-tablet">
          <ImageWrapper data-testid="vehicle-info-image">
            <VehicleImage src={image} />
          </ImageWrapper>

          <Title paddingTop>{t('digitalLeads.vehicle.offerOfInterest')}</Title>
          <OfferType>{t(`digitalLeads.vehicle.offers.${offers?.offerType}`)}</OfferType>
          <>
            <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
            <Trimline>{trimName}</Trimline>
          </>
          <Offers offers={offers?.offerDetails} offerType={offers.offerType} />
        </VehicleInfoContainer>
      )}
    </>
  );
};

export default OfferSpecificVehicle;
